import { Link } from 'react-router';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const saleType = 'sale';
const rentalType = 'rental';

const SaleRentalToggle = ({baseRoute, cleanFilter, currentType, handleToggle, onLanding, supportsRentals}) => {
  const [saleTabFocused, setSaleTabFocused] = useState(currentType === saleType);
  let controls = null;
  if (supportsRentals) {
    controls = (
      <React.Fragment>
        <Link
          role="tab"
          aria-controls="search-listing-tabpanel"
          id="search-sales-tab"
          tabIndex={currentType === saleType ? '0' : '-1'}
          aria-selected={currentType === saleType ? 'true' : 'false'}
          to={{ pathname: `${baseRoute}/sales`, query: cleanFilter }}
          onClick={handleToggle.bind(this, 'sales')}
          className={currentType === saleType ? 'active' : ''}
        >
          Sales
        </Link>
        <Link
          role="tab"
          aria-controls="search-listing-tabpanel"
          id="search-rentals-tab"
          tabIndex={currentType === rentalType ? '0' : '-1'}
          aria-selected={currentType === rentalType ? 'true' : 'false'}
          to={{ pathname: `${baseRoute}/rentals`, query: cleanFilter }}
          onClick={handleToggle.bind(this, 'rentals')}
          className={currentType === rentalType ? 'active' : ''}
        >
          Rentals
        </Link>
      </React.Fragment>
    );
  }

  const toggleFocus = () => {
    if (saleTabFocused) {
      document.getElementById('search-rentals-tab').focus();
      setSaleTabFocused(false);
    } else {
      document.getElementById('search-sales-tab').focus();
      setSaleTabFocused(true);
    }
  }

  const onKeyDown = (e) => {
    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowLeft':
        toggleFocus();
        break;
      default:
    }
  }
  
  return (
    <div id="sale-rental-tablist" onKeyDown={onKeyDown} className="action-symbols grid-list-toggle" role="tablist">
      {controls}
    </div>
  );
}

SaleRentalToggle.propTypes = {
  baseRoute: PropTypes.string.isRequired,
  cleanFilter: PropTypes.object.isRequired,
  currentType: PropTypes.string.isRequired,
  handleToggle: PropTypes.func.isRequired,
  onLanding: PropTypes.bool.isRequired,
  supportsRentals: PropTypes.bool.isRequired
};

export default SaleRentalToggle;



// WEBPACK FOOTER //
// ./src/components/search/controls/sale-rental-toggle.jsx